var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("page-header", {
        attrs: {
          actions: [
            {
              text: "Añadir",
              icon: "fas fa-save",
              variant: "success",
              component: "ActionButton",
              click: () => this.add(),
              visible: _vm.userHasPermissions("provider.specialists.add")
            }
          ],
          page: _vm.page
        }
      }),
      _c("filter-manager", {
        ref: "filterComponent",
        attrs: { filters: _vm.filtersConfig },
        on: { search: _vm.search },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _vm.hasSearched
        ? _c("separator", {
            staticClass: "my-3",
            attrs: { text: "Resultado de Especialistas" }
          })
        : _vm._e(),
      _vm.hasSearched && _vm.results.length === 0
        ? _c("result-not-found")
        : _vm._e(),
      _vm._l(_vm.results, function(item) {
        return _c(
          "div",
          { key: item.id },
          [
            _c("custom-callout", { class: !_vm.showAlert(item) && "mb-3" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm border-right" }, [
                  _c("span", { staticClass: "data-name" }, [
                    _vm._v("Especialista:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(" " + _vm._s(item.fullName) + " ")
                  ])
                ]),
                _c("div", { staticClass: "col-sm" }, [
                  _c("span", { staticClass: "data-name" }, [
                    _vm._v("Número Especialista:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(" " + _vm._s(item.id) + " ")
                  ])
                ]),
                _c("div", { staticClass: "col-sm-12 col-md-2" }, [
                  _c("span", { staticClass: "data-name" }, [
                    _vm._v("Estatus:")
                  ]),
                  _c(
                    "div",
                    { staticClass: "w-70" },
                    [
                      _c("balloon", {
                        attrs: {
                          "color-icon": `color-primary-${
                            item.isActive ? "7" : "6"
                          }`,
                          icon: "fas fa-circle",
                          text: item.isActive ? "Activo" : "Inactivo",
                          "with-border": false
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "col-md-4 col-sm-12" }, [
                  _c("span", { staticClass: "data-name" }, [
                    _vm._v("Especialidad:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(" " + _vm._s(item.specialty) + " ")
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col d-flex align-items-center justify-content-md-end justify-content-sm-start"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "w-sm-40 w-md-70" },
                      [
                        _c("action-button", {
                          staticClass: "w-100",
                          attrs: {
                            i: "fas fa-file-import",
                            text: "Entrar",
                            variant: "outline-success"
                          },
                          on: {
                            click: () =>
                              _vm.$router.push({
                                name: "specialist-management",
                                params: {
                                  title: "Especialista: Editar",
                                  specialistId: item.id,
                                  companyId: _vm.companyId,
                                  fiscalYearId: item.fiscalYearId,
                                  isActive: item.isActive,
                                  isDEPR:
                                    item.moreThanOneCompany &&
                                    item.hasExcemptionApproved
                                }
                              })
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ]),
            _vm.showAlert(item)
              ? _c(
                  "div",
                  {
                    staticClass:
                      "alert rb-alert px-2 rounded pt-2 mb-n0 alert-container mb-3"
                  },
                  [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("em", {
                        staticClass:
                          "fa fa-bell-exclamation font-16 pl-2 ml-1 color-secondary-40"
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "font-16 font-weight-normal color-secondary-40 ml-3 alert-text"
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.alertText(item)) }
                          }),
                          item.moreThanOneCompany && item.hasExcemptionDenied
                            ? _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  " La dispensa fue denegada por el Departamento de Educación de Puerto Rico, para ver la razón "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "text-dark-yellow text-underline font-weight-bold cursor-pointer",
                                    on: {
                                      click: _vm.navigateToDispenseManagement
                                    }
                                  },
                                  [_vm._v(" oprima aquí. ")]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      }),
      this.results.length > 0 && this.pagination.totalItemCount > 15
        ? _c("pagination", {
            attrs: { data: this.pagination },
            on: { "pagination-go-page": _vm.pageChanged }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }